export default __webpack_public_path__ + "static/media/ongoing-background.332db9ac.png";